import { InjectionToken } from '@angular/core';


export const IWIZ_COMPONENT = new InjectionToken('IWIZ_COMPONENT');

/**
 * Interface de base de tous les composants
 */
export interface IWIZComponent {

  /** Component UID: clé technique pour traçabilité */
  entityUID: string;

  /** mandatory field */
  wizMandatory: boolean;

  /** composant désactivé */
  wizDisabled: boolean;
  setWizDisabled(v: boolean): void; // pour override
  getWizDisabled(): boolean; // pour override

  // undisableable
  undisableable: boolean;

  /** label field */
  wizLabel: string;

  /** id: identifiant technique alimenté manuellement */
  id: string;
}
